import Immutable from 'immutable';

import ParameterRestriction from 'sharedreact/data/ParameterRestriction';
import Predicate from 'sharedreact/data/Predicate';
import TypeInfo from 'sharedreact/data/TypeInfo';

const Content: {
  optionNames: Immutable.List<string>,
  userDisplayName: string,
  defaultIndex: number,
  restrictedValues: Immutable.List<ParameterRestriction>,
  typeInfos: Immutable.List<TypeInfo>,
  displayNames: Immutable.List<string>,
  visibleIfPredicate: Predicate | null,
  enabledIfPredicate: Predicate | null
} = {
  optionNames: Immutable.List(),
  userDisplayName: '',
  defaultIndex: -1,
  restrictedValues: Immutable.List(),
  typeInfos: Immutable.List(),
  displayNames: Immutable.List(),
  visibleIfPredicate: null,
  enabledIfPredicate: null
};

class PublicParameter extends Immutable.Record(Content) {
  get labelName (): string {
    return (this.userDisplayName || (this.displayNames.size > 0 ? this.displayNames.get(0) : '') || '');
  }
}

export default PublicParameter;
